export const requestStatus = {
	ENDED: 'ENDED',
	COMPLETED: 'COMPLETED',
	IN_PROGESS: 'IN_PROGRESS',
	NOT_INITIATED: 'NOT_INITIATED',
};
